module.exports = __webpack_public_path__ + "assets/events_white.64d438b5.svg";